import { truncateTextWithEllipsis } from '@utilities';

import { SEARCH_PARAM_KEYS } from '../../../pages/Survey/utilities/constants';

/**
 * Gets filter details for xlsx
 * @param {Object} options - Configuration options
 * @param {Object} options.globalFilters - Global filters object
 * @param {URLSearchParams} options.searchParams - URL search parameters
 * @param {Object} options.survey - Survey object with quota groups
 * @param {Array} options.surveyQuestions - Survey questions for question details
 * @returns {Object} Object of Demographic, Question Option, and Quota Group filter descriptions
 */
export const getAppliedFiltersModal = ({
  globalFilters,
  searchParams,
  survey = null,
  surveyQuestions = [],
}) => {
  const FILTERS = {
    'Demographic Filters': [],
    'Question Option Filters': [],
    'Quota Group Filters': [],
  };

  if (!searchParams || !globalFilters) return FILTERS;

  // Quota group filters
  const quotaGroupFilter = searchParams.get(SEARCH_PARAM_KEYS.QUOTA_GROUP);
  let selectedGroupIds = [];
  if (quotaGroupFilter) {
    selectedGroupIds = quotaGroupFilter.split(',').filter(Boolean);
  } else if (globalFilters?.quotaGroups) {
    selectedGroupIds = globalFilters.quotaGroups.map(
      ({ instantSurveyGroupRef }) => instantSurveyGroupRef
    );
  }

  if (selectedGroupIds.length > 0 && survey?.groups && Array.isArray(survey.groups)) {
    const selectedGroups = [];
    selectedGroupIds.forEach((groupId) => {
      const group = survey.groups.find((g) => g && String(g.id) === String(groupId));
      if (group && group.name) {
        selectedGroups.push(group.name);
      }
    });

    if (selectedGroups.length > 0) {
      selectedGroups.forEach((groupName) => {
        FILTERS['Quota Group Filters'].push(groupName);
      });
    }
  }
  if (FILTERS['Quota Group Filters'].length === 0) {
    FILTERS['Quota Group Filters'].push('None');
  }

  // Demographic filters
  if (globalFilters?.demographicFilters) {
    globalFilters.demographicFilters.forEach(({ id, label }) => {
      const filterValue = searchParams.get(id);
      if (filterValue && filterValue.split(',').filter(Boolean).length > 0) {
        FILTERS['Demographic Filters'].push(label);
      }
    });
    if (FILTERS['Demographic Filters'].length === 0) {
      FILTERS['Demographic Filters'].push('None');
    }
  }

  // Question option filters
  const selectedOptionIds = (searchParams.get(SEARCH_PARAM_KEYS.QUESTION_OPTION) || '')
    .split(',')
    .filter(Boolean);
  const questionsToCheck = Array.isArray(surveyQuestions) ? surveyQuestions : [];

  if (selectedOptionIds.length === 0) {
    FILTERS['Question Option Filters'].push('None');
  } else if (questionsToCheck.length > 0) {
    selectedOptionIds.forEach((optionId) => {
      questionsToCheck.forEach((question) => {
        if (question?.options && Array.isArray(question.options)) {
          const match = question.options.find((opt) => String(opt?.id) === String(optionId));
          if (match) {
            FILTERS['Question Option Filters'].push(
              `Q${question.id}: ${truncateTextWithEllipsis({ length: 45, text: question.title })}: ${truncateTextWithEllipsis({ length: 25, text: match.title })}`
            );
          }
        }
      });
    });

    if (FILTERS['Question Option Filters'].length === 0) {
      FILTERS['Question Option Filters'].push('None');
    }
  }

  return FILTERS;
};
